import React from "react";
import {useTranslation} from 'react-i18next';



const InvoiceHeroSection = ({onScrollToForm}) =>{
    const {t}=useTranslation('invoicepage');
    return(
        <section className='section-container'> 
            <div className='invoice-hero-section'>
                <div className="left-invoice-hero-section">
                    <div className="left-invoice-hero-section-content">
                    <span>{t('left-invoice-hero-section.line1')}</span> {t('left-invoice-hero-section.line2')} <br/>{t('left-invoice-hero-section.line3')}<br/>
                    <span id="left-invoice-hero-section-content">{t('left-invoice-hero-section.line4')}</span>
                    <p>{t('left-invoice-hero-section.line5')}</p>
                    <button className="btn-big btn-primary btn-mobile" onClick={onScrollToForm}>{t('left-invoice-hero-section-button')}</button>
                </div> 
                </div>
                        
                <div className="right-invoice-hero-section">
                <div className="right-invoice-hero-section-content">
                    <img src="/images/invoice_hero_section.webp" alt="retailInvoice" />
                </div>
                </div> 
            </div>    
        </section>
    )
}

export default InvoiceHeroSection;